import DashboardPage from '@pages/DashboardPage';
import Paths from './paths';
import LoginPage from '@pages/LoginPage';
import FindProfileCard from '@/modules/FindProfile';
import CvVideoRecordPage from '@pages/CvVideoRecordPage';
import ChoosePhotosCard from '@authentication/components/ChoosePhotos';
import TakePhotoPage from '@pages/TakePhotoPage';
import SpacePage from '@pages/SpacePage';
import LogoutPage from '@pages/LogoutPage';

interface Route {
  path: string;
  component: React.ReactNode;
  label?: string;
  private: boolean;
  icon?: React.JSX.Element;
  showHeader: boolean;
}

const routes: Route[] = [
  {
    label: 'LOGIN',
    path: Paths.LoginPage,
    private: false,
    component: <LoginPage />,
    showHeader: false,
  },
  {
    label: 'DASHBOARD',
    path: Paths.DashboardPage,
    private: true,
    component: <DashboardPage />,
    showHeader: false,
  },
  {
    label: 'FINDPROFILE',
    path: Paths.FindProfilePage,
    private: true,
    component: <FindProfileCard />,
    showHeader: true,
  },
  {
    label: 'CVRECORDCIDEO',
    path: Paths.CvVideoRecordPage,
    private: true,
    component: <CvVideoRecordPage />,
    showHeader: true,
  },
  {
    label: 'CHOOSEPHOTOS',
    path: Paths.ChoosePhotosPage,
    private: true,
    component: <ChoosePhotosCard />,
    showHeader: true,
  },
  {
    label: 'TakePhoto',
    path: Paths.TakePhoto,
    private: true,
    component: <TakePhotoPage />,
    showHeader: true,
  },
  {
    label: 'Space',
    path: Paths.SpacePage,
    private: true,
    component: <SpacePage />,
    showHeader: false,
  },
  {
    label: 'Logout',
    path: Paths.LogoutPage,
    private: true,
    component: <LogoutPage />,
    showHeader: false,
  },
];

export default routes;
